export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
    $(".senpro-testimonial").slick({
      centerMode: true,
      centerPadding: "60px",
      slidesToShow: 2,
      dots: true,
      appendArrows: $(".controls-container"),

      appendDots: $(".controls-container .dots"),

      responsive: [
        {
          breakpoint: 768,
          settings: {
            arrows: false,
            centerMode: true,
            centerPadding: "40px",
            slidesToShow: 3,
            adaptiveHeight: true,
          },
        },
        {
          breakpoint: 480,
          settings: {
            arrows: false,
            centerMode: true,
            centerPadding: "10px",
            slidesToShow: 1,
            adaptiveHeight: true,
          },
        },
      ],
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/senpro.js